<template>
  <div id="data-source-modal" class="editor-modal">
    <div class="create">
      <h2>{{ $t("create-data.title") }}</h2>
      <!-- <form @submit.stop.prevent> -->
      <form @submit="onCreate">
        <radio-button
          lightLabel
          :listClasses="'radio-btns'"
          v-model="dataPicked"
          :label="isFixed ? $t('create-data.type-fixed') : $t('create-data.type-custom')"
          :options="radioButtonOptions"
        />

        <div class="if-custom" v-if="dataPicked === 'custom'">
          <custom-input
            :inputType="'text'"
            v-model="customSource.name"
            :name="'nameInput'"
            :label="$t('create-data.name')"
            :placeholder="$t('create-data.name-ph')"
            :focusInputField="true"
          />
        </div>

        <div v-if="dataPicked === 'dummy'">
          <custom-input
            :inputType="'text'"
            v-model="dummySource.name"
            :name="'nameInput'"
            :label="$t('create-data.name')"
            :placeholder="$t('create-data.name-ph')"
            :focusInputField="true"
          />
        </div>

        <div class="footer">
          <!-- <img src="logo.png" alt="logo" /> -->
          <button class="btn btn-md btn-primary" :disabled="!valid" @click="onCreate">
            {{ $t("template.cr-tp-btn-create") }}
          </button>
          <button class="btn btn-md btn-secondary" type="reset" @click="$emit('close')">
            {{ $t("template.cr-tp-btn-cancel") }}
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import CustomInput from "@/components/CustomInput";
import RadioButton from "@/components/RadioButton";
export default {
  props: {
    contentSources: Array,
    currentType: Object,
    onSave: Function,
    isFixed: Boolean
  },
  data() {
    return {
      customSource: {
        name: "",
        searchURL: "",
        dataURL: "",
        exampleId: "",
        dummy: false,
        type: this.currentType
      },

      dummySource: {
        name: "",
        searchURL: "",
        dataURL: "",
        exampleId: "",
        dummy: true,
        type: this.currentType
      },

      contentSource: null,
      contentType: null,
      language: null,
      working: false,

      dataPicked: "custom",
      radioButtonOptions: [
        // Fixed value is added in mounted if needed
        { value: "custom", name: "custom-data", label: "Endpoints" },
        { value: "dummy", name: "dummy-data", label: this.$t("data.dummy") }
      ]
    };
  },

  methods: {
    onCreate(evt) {
      evt.preventDefault();
      if (this.dataPicked === "dummy") {
        this.onSave(this.dummySource);
        this.$emit("close");
      }
      if (this.dataPicked === "custom") {
        this.onSave(this.customSource);
        this.$emit("close");
      }

      if (this.dataPicked === "fixed") {
        this.onSave("fixed");
        this.$emit("close");
      }
    }
  },
  computed: {
    valid() {
      //  if(this.dataPicked === 'dummy'){return this.dummySource.name }
      //  else {return this.customSource.name }
      if (this.dataPicked === "dummy") {
        return this.dummySource.name;
      } else if (this.dataPicked === "fixed") {
        return "fixed";
      } else {
        return this.customSource.name;
      }
    }
  },
  mounted() {
    if (this.isFixed) {
      this.radioButtonOptions.unshift({ value: "fixed", name: "connector-data", label: "Connector" });
      this.dataPicked = "fixed";
    }
  },
  components: {
    CustomInput,
    RadioButton
  }
};
</script>

<style lang="less">
#data-source-modal {
  padding: 30px 25px 25px 25px;
  h2 {
    margin: 0;
  }
  .form-group {
    margin-bottom: 0;
  }
  .footer {
    margin-top: 40px;
  }
  .radio-btns {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    padding-top: 12px;
  }
}
</style>
